module.exports = __webpack_public_path__ + "static/media/yearlylist.f9cc2aaf.png";